<template>
  <nd-dialog
    v-model="visible"
    close-btn
  >
    <div class="dialog-content" slot="custom">
      <div class="title">提示</div>
      <div class="info">购买链接已复制到剪切板，请打开浏览器粘贴链接进行支付。</div>
      <div class="btn-group">
        <div class="btn copy" @click="hanldeCopy">复制链接</div>
        <div class="btn complete" @click="handleComplete">我已完成支付</div>
      </div>
    </div>
  </nd-dialog>
</template>

<script>
import { copyToClipbord } from '@/assets/utils'

export default {
  name: 'BuyDialogJw',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    copyUrl: {
      type: String,
      default: ''
    }
  },
  computed: {
    visible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    // 复制链接
    hanldeCopy () {
      copyToClipbord(this.copyUrl)
      this.$message('购买链接已复制到剪切板，请打开浏览器粘贴链接进行支付。')
    },
    // 点击完成支付
    handleComplete () {
      this.visible = false
      this.$emit('on-complete')
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.dialog-content {
  background-color: #fff;
  width: 620px;
  border-radius: 30px;
  padding: 50px 40px 75px;
  .title{
    font-size: 38px;
    color: #333333;
    text-align: center;
    line-height: 72px;
    font-weight: bold;
  }
  .info{
    font-size: 28px;
    color: #666666;
    text-align: center;
    line-height: 45px;
    margin-top: 25px;
  }
  .btn-group{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 65px;
    .btn{
      width: 440px;
      height: 80px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 32px;
      border: 2px solid #FF4633;
      border-radius: 40px;
      &.copy{
        color: #FF4633;
      }
      &.complete{
        background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
        color: #ffffff;
      }
      & + .btn{
        margin-top: 20px;
      }
    }
  }
}
</style>
